// extracted by mini-css-extract-plugin
export default {"mdMain":"ChangeRegMode_mdMain__pILep"};